import React from "react";

export const Solutions = () => {
  const solutions = [
    {
      icon: "fa fa-building",
      title: "Small and Growing Businesses",
      description: "Whether you're a startup or scaling enterprise, Peak Risk Management helps you stay ahead of incidents, streamline safety, and manage claims—so you can grow with confidence."
    },
    {
      icon: "fa fa-truck",
      title: "Fleet and Transportation Operators",
      description: "From delivery vans to service trucks, if wheels are turning, risks are rolling. Our platform helps you track incidents, manage claims, and protect your drivers and assets."
    },
    {
      icon: "fa fa-heartbeat",
      title: "Healthcare and Wellness Providers",
      description: "In environments where safety and compliance are critical, Peak Risk Management offers clarity and control—helping you manage incidents, protect staff, and ensure patient trust."
    },
    {
      icon: "fa fa-cogs",
      title: "Field and Manufacturing Services",
      description: "On job sites where every day brings new risks, our tools help you document incidents, enforce safety protocols, and reduce costly claims—keeping projects on track."
    },
    {
      icon: "fa fa-shield",
      title: "Insurance and Risk Professionals",
      description: "For those who live in the world of claims, policies, and analytics, Peak Risk Management is your command center—bringing together data, documentation, and insights in one powerful place."
    }
  ];

  return (
    <div id="solutions" className="section" style={{ backgroundColor: '#F9FAFB' }}>
      <div className="container">
        <div className="section-title">
          <h2>Solutions</h2>
          <p>Tailored risk management solutions for every industry and business size</p>
        </div>
        <div className="solutions-grid">
          {solutions.map((solution, i) => (
            <div key={`${solution.title}-${i}`} className="col-xs-12 col-md-6 col-lg-4">
              <div className="solution-card">
                <div className="solution-icon">
                  <i className={solution.icon}></i>
                </div>
                <h3>{solution.title}</h3>
                <p>{solution.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
